export default "__VITE_ASSET__DwGQ$Mmf__"